import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { TABLE_DEFINITION, VaFilteredMatTableService, VaTableSortService } from '@vendasta/va-filter2-table';
import { tableDefinitionFactory } from './package-selector-table-model';
import { PackageSelectorService } from './package-selector.service';
import { FilterService } from '@vendasta/va-filter2';
import { VaFilteredMatTableComponent } from '@vendasta/va-filter2-table';
import { Package } from '@vendasta/marketplace-packages';
import { PackageWithPrice } from './package-with-price';

@Component({
  selector: 'sales-ui-sales-order-package-selector',
  templateUrl: './package-selector.component.html',
  providers: [
    VaTableSortService,
    PackageSelectorService,
    VaFilteredMatTableService,
    FilterService,
    { provide: TABLE_DEFINITION, useFactory: tableDefinitionFactory, deps: [PackageSelectorService] },
  ],
})
export class PackageSelectorComponent implements OnInit, OnChanges {
  @Input() preselectedPackages: Package[];
  @Input() marketId: string;

  @ViewChild('table') table: VaFilteredMatTableComponent<PackageWithPrice>;

  preselectedPackagesWithPrices: PackageWithPrice[];

  constructor(readonly dataService: PackageSelectorService) {}

  ngOnInit(): void {
    this.dataService.setMarketId(this.marketId);
  }

  ngOnChanges(): void {
    this.preselectedPackagesWithPrices = this.preselectedPackages.map((pkg) => {
      return {
        package: pkg,
        price: null,
      };
    });
  }

  getSelectedRows(): Package[] {
    return this.table.getSelectedRows().map((row) => {
      return row.package;
    });
  }
}
